import { render, staticRenderFns } from "./BookMetaAdd.vue?vue&type=template&id=cf31d364&"
import script from "./BookMetaAdd.vue?vue&type=script&lang=js&"
export * from "./BookMetaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports